import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import SliderTable from './SliderTable';
const Sliders = () => {
  return (
    <Fragment>
      <Breadcrumbs parent='Sliders' mainTitle='Sliders' />
      <Container fluid={true}>
        <Row>
          <SliderTable/>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Sliders;
